import { ACTIVE_PROJECT_TYPE } from 'src/data/project';
import { getToneOfVoiceForGeneration } from 'src/data/toneOfVoice';

import { AI_RECOMPOSE_MODE, GENERATION_IMPROVE_MODE } from './const';

const MAKE_CASUAL_INSTRUCTIONS = 'Use more casual terminology but keep it similar.';
const MAKE_LONGER_INSTRUCTIONS = 'make it longer';
const MAKE_SHORTER_INSTRUCTIONS = 'make it shorter';

export const getGenerationImproveParams = ({ projectType, improveParams }) => {
  // Prepare generation params for "document" project type
  if (projectType === ACTIVE_PROJECT_TYPE.document) {
    const recomposeMode = generationImproveModeToRecomposeModeDocument(improveParams.improveMode);

    let instructions = improveParams.instructions;
    if (improveParams.improveMode === GENERATION_IMPROVE_MODE.makeCasual) {
      instructions = MAKE_CASUAL_INSTRUCTIONS;
    } else if (improveParams.improveMode === GENERATION_IMPROVE_MODE.makeLonger) {
      instructions = MAKE_LONGER_INSTRUCTIONS;
    } else if (improveParams.improveMode === GENERATION_IMPROVE_MODE.makeShorter) {
      instructions = MAKE_SHORTER_INSTRUCTIONS;
    }

    let tovInput;
    if (improveParams.improveMode === GENERATION_IMPROVE_MODE.changeTov) {
      const { tov, customModelId, draftToneOfVoice } = improveParams.tov;
      tovInput = getToneOfVoiceForGeneration(customModelId || tov, draftToneOfVoice);
    }

    return {
      recomposeMode,
      instructions,
      tovInput,
    };
  }

  // Prepare generation params for "blog" project type
  if (projectType === ACTIVE_PROJECT_TYPE.blogPostBuilder) {
    const recomposeMode = generationImproveModeToRecomposeModeLongForm(improveParams.improveMode);

    let instructions = improveParams.instructions;
    if (improveParams.improveMode === GENERATION_IMPROVE_MODE.makeCasual) {
      instructions = MAKE_CASUAL_INSTRUCTIONS;
    }

    let tovInput;
    if (improveParams.improveMode === GENERATION_IMPROVE_MODE.changeTov) {
      const { tov, customModelId, draftToneOfVoice } = improveParams.tov;
      tovInput = getToneOfVoiceForGeneration(customModelId || tov, draftToneOfVoice);
    }

    return {
      recomposeMode,
      instructions,
      tovInput,
    };
  }

  // Prepare generation params for "long form" project type
  if (projectType === ACTIVE_PROJECT_TYPE.longFormBuilder) {
    const recomposeMode = generationImproveModeToRecomposeModeLongForm(improveParams.improveMode);

    let instructions = improveParams.instructions;
    if (improveParams.improveMode === GENERATION_IMPROVE_MODE.makeCasual) {
      instructions = MAKE_CASUAL_INSTRUCTIONS;
    }

    let tovInput;
    if (improveParams.improveMode === GENERATION_IMPROVE_MODE.changeTov) {
      const { tov, customModelId, draftToneOfVoice } = improveParams.tov;
      tovInput = getToneOfVoiceForGeneration(customModelId || tov, draftToneOfVoice);
    }

    return {
      recomposeMode,
      instructions,
      tovInput,
    };
  }

  return null;
};

export const IMPROVE_RECOMPOSE_CONTENT_IMPROVER_OPTIONS = [
  GENERATION_IMPROVE_MODE.makeCasual,
  GENERATION_IMPROVE_MODE.makeLonger,
  GENERATION_IMPROVE_MODE.makeShorter,
];

const IMPROVE_RECOMPOSE_DOCUMENT_MAP = {
  [GENERATION_IMPROVE_MODE.improveEngaging]: AI_RECOMPOSE_MODE.relaxed,
  [GENERATION_IMPROVE_MODE.improveSimilar]: AI_RECOMPOSE_MODE.strict,
  [GENERATION_IMPROVE_MODE.boostScoreEngaging]: AI_RECOMPOSE_MODE.relaxed,
  [GENERATION_IMPROVE_MODE.boostScoreSimilar]: AI_RECOMPOSE_MODE.strict,
  [GENERATION_IMPROVE_MODE.makeCasual]: AI_RECOMPOSE_MODE.instructionBased,
  [GENERATION_IMPROVE_MODE.makeLonger]: AI_RECOMPOSE_MODE.instructionBased,
  [GENERATION_IMPROVE_MODE.makeShorter]: AI_RECOMPOSE_MODE.instructionBased,
  [GENERATION_IMPROVE_MODE.changeTov]: AI_RECOMPOSE_MODE.tov,
  [GENERATION_IMPROVE_MODE.instructions]: AI_RECOMPOSE_MODE.instructionBased,
};
export const generationImproveModeToRecomposeModeDocument = (improveMode) =>
  IMPROVE_RECOMPOSE_DOCUMENT_MAP[improveMode];

const IMPROVE_RECOMPOSE_LONG_FORM_MAP = {
  [GENERATION_IMPROVE_MODE.improveEngaging]: AI_RECOMPOSE_MODE.refine,
  [GENERATION_IMPROVE_MODE.improveSimilar]: AI_RECOMPOSE_MODE.strict,
  [GENERATION_IMPROVE_MODE.boostScoreEngaging]: AI_RECOMPOSE_MODE.refine,
  [GENERATION_IMPROVE_MODE.boostScoreSimilar]: AI_RECOMPOSE_MODE.strict,
  [GENERATION_IMPROVE_MODE.makeCasual]: AI_RECOMPOSE_MODE.instructionBased,
  [GENERATION_IMPROVE_MODE.makeLonger]: AI_RECOMPOSE_MODE.expand,
  [GENERATION_IMPROVE_MODE.makeShorter]: AI_RECOMPOSE_MODE.shorten,
  [GENERATION_IMPROVE_MODE.changeTov]: AI_RECOMPOSE_MODE.tov,
  [GENERATION_IMPROVE_MODE.instructions]: AI_RECOMPOSE_MODE.instructionBased,
};
export const generationImproveModeToRecomposeModeLongForm = (improveMode) =>
  IMPROVE_RECOMPOSE_LONG_FORM_MAP[improveMode];

const GENERATION_IMPROVE_MODE_PROPS = {
  [GENERATION_IMPROVE_MODE.improveEngaging]: {
    label: 'Improve',
  },
  [GENERATION_IMPROVE_MODE.improveSimilar]: {
    label: 'Improve',
  },
  [GENERATION_IMPROVE_MODE.boostScoreEngaging]: {
    label: 'Improve performance',
  },
  [GENERATION_IMPROVE_MODE.boostScoreSimilar]: {
    label: 'Improve performance but keep structure',
  },
  [GENERATION_IMPROVE_MODE.makeCasual]: {
    label: 'Make more casual',
  },
  [GENERATION_IMPROVE_MODE.makeLonger]: {
    label: 'Make longer',
  },
  [GENERATION_IMPROVE_MODE.makeShorter]: {
    label: 'Make shorter',
  },
  [GENERATION_IMPROVE_MODE.changeTov]: {
    label: 'Change tone of voice',
  },
};

export const getGenerationImproveModeLabel = (type) => GENERATION_IMPROVE_MODE_PROPS[type]?.label;
